<div *ngIf="indexPage == fadIndex">
    <h3 class="title">{{ formADMessage.title | translate }}</h3>
    <span class="d-block"><span class="required">{{ formADMessage.requis1 | translate }}</span>{{ formADMessage.requis2
        | translate }}</span>

    <span class="d-block infos">{{ formADMessage.infos | translate }}</span>

    <app-form-input [parentForm]="form" [disabled]="disabled" [value]="radioButtonValue"
        [label]="formADMessage.afficherlogo" [type]="'radio'" [rule]="''" [radios]="[
            {
                label: formADMessage.oui,
                value: ouiValue
            },
            {
                label: formADMessage.non,
                value: nonValue
            }
        ]" [name]="radioButtonCtrlName">
    </app-form-input>

    <div *ngIf="isOui()">
        <label class="bold txtcenter container">{{ formADMessage.addlogo | translate }}</label>
        <div class="container containerLogo" appDnd (fileDropped)="onFileDropped($event)">
            <input type="file" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event.target.files)" />
            <h3>{{ formADMessage.drag | translate }}</h3>
            <h3>{{ formADMessage.or | translate }}</h3>
            <label for="fileDropRef">{{ formADMessage.choisir | translate }}</label>
        </div>
        <div class="files-list">
            <div class="single-file" *ngIf="file !== null">
                <div class="info">
                    <h4 class="name">
                        {{ file?.name }}
                    </h4>
                    <p class="size">
                        {{ formatBytes(file?.size) }}
                    </p>
                </div>
                <div class="delete" (click)="deleteFile()">
                    <mat-icon>delete_forever</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <div [formGroup]="form">
        <button (click)="generateAD()" id="generateAD" type="button" class="btn btn-outline-primary">
            Générer le formulaire adapté
        </button>
        <label class="bold" [for]="getUid()+'_SepAtt_TextArea'" [translate]="formADMessage.contenu">
        </label>
        <angular-editor [formControlName]="getUid()+'_SepAtt_TextArea'" [config]="editorConfig"></angular-editor>
    </div>

</div>
